<template lang="pug">
.searchPanel
  .simpleSearch(v-if="filtro.simples && exibirFiltro", key="simpleSearch")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      validation-observer(v-slot="{ invalid }")
        validation-provider(name="Campo Simples" :rules=" campoSimplesObrigatorio ? 'required' : ''", v-slot="{ errors }")
          el-input.input(
            :placeholder="placeholder",
            v-model="filtro.campoSimples",
            :class="pesquisaGeral ? 'pesquisaGeralInput' : 'input-with-select'"
          )
            el-button.color-default(
              slot="append",
              icon="el-icon-search",
              id="botao-filtro-simplificado",
              @click="pesquisar(invalid)",
              :class="pesquisaGeral ? 'pesquisaGeralButton' : ''"
            )
          .limpar-e-erro(v-if="campoSimplesObrigatorio")
            el-button.limpar(
              type="text",
              @click="limpar"
            ) Limpar
            span(v-if="errors.length && showErro").erro Por favor, preencha o campo.
  .advancedSearch(v-if="!filtro.simples && exibirFiltro")
    form(@submit.prevent="$emit('pesquisar', filtro)")
      .panel
        el-row(:gutter="10")
          el-col(:lg="6", :md="12", :sm="24", v-if="!this.caixasCadastroPendente.includes(this.caixa)")
            p.titulo Processo:
            el-input(
              v-model="filtro.numeroProcesso",
              v-mask="['#########/####']"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroNumeroRecibo')")
            p.titulo Número do Recibo:
            el-input(
              v-model="numeroRecibo",
              v-mask="['AAA-XXXXXX-XXXXXXX-####']"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
            p.titulo Período de Solicitação:
            el-date-picker.full-width.input.date(
              v-bind="$attrs",
              type="daterange",
              start-placeholder="Período inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.periodoSolicitacao"
              name='data',
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroResponsavel') && !this.isBa")
            p.titulo Responsável:
            el-select.full-width(
              v-model='filtro.responsavel',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Responsável não encontrado",
              @clear="filtro.responsavel = null"
            )
              el-option(
                v-for='responsavel in responsaveis',
                :key='responsavel.id',
                :label='responsavel.nomeCargo',
                :value='responsavel.id'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroCredenciado')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.credenciado',
              placeholder='Selecione',
              clearable,
              filterable,
              no-match-text="Credenciado não encontrado",
              @clear="filtro.credenciado = null"
            )
              el-option(
                v-for='credenciado in credenciados',
                :key='credenciado',
                :label='credenciado',
                :value='credenciado'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroVistoriador')")
            p.titulo Credenciado:
            el-select.full-width(
              v-model='filtro.tipoCredenciado',
              placeholder='Selecione',
              clearable,
              @clear="filtro.tipoCredenciado = null"
            )
              el-option(
                v-for='tipo in tipoCredenciado',
                :key='tipo.codigo',
                :label='tipo.name',
                :value='tipo.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacaoTituloCertidao')")
            p.titulo Situação:
            el-select.full-width(
              v-model='filtro.status',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='situacao in situacaoTituloCertidao',
                :key='situacao.codigo',
                :label='situacao.nome',
                :value='situacao.codigo'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroOS')")
            p.titulo Ordem de Serviço:
            el-select.full-width(
              v-model='filtro.numeroOs',
              placeholder='Selecione',
              clearable,
              filterable
            )
              el-option(
                v-for='ordemServico in ordemServicoList',
                :key='ordemServico.id',
                :label='ordemServico.label',
                :value='ordemServico.label'
              )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroOrdemServico')")
            p.titulo Ordem de Serviço:
            el-input(
              v-model="filtro.numeroOs"
            )
          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroFuncao')")
            p.titulo Função:
            el-select.full-width(
              v-model='filtro.funcao',
              placeholder='Selecione',
              clearable
            )
              el-option(
                v-for='funcao in funcoes',
                :key='funcao.codigo',
                :label='funcao.nome',
                :value='funcao.codigo'
              )
          div
            el-col(:lg="6", :md="12", :sm="24", v-if="!showfiltrosInformacoes && (!showFiltroPublicacaoPortaria && !showFiltroPublicacao)")
              p.titulo CPF/CNPJ do Interessado:
              el-input.input(
                v-model="filtro.cpfCnpjInteressado",
                class="input-with-select",
                v-mask="['###.###.###-##', '##.###.###/####-##']"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
              p.titulo Setor de Origem:
              el-select.full-width(
                v-model='filtro.setorOrigem',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='setor in setores'
                  :key='setor.id'
                  :label='setor.nome',
                  :value='setor.codigo'
                )

            el-col(:lg="6", :md="12", :sm="24", v-if="!showfiltrosInformacoes")
              p.titulo Nome/Razão Social do Interessado:
              el-input(
                v-model="filtro.nomeInteressado"
              )
            el-col(:lg="6", :md="12", :sm="24" v-if="showFiltro('filtroClausulaResolutiva')")
              p.titulo Situação cláusula resolutiva:
              el-select.full-width(
                v-model='filtro.situacaoClausulaResolutiva',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='tipo in situacaoClausulaResolutiva',
                  :key='tipo.codigo',
                  :label='tipo.nome',
                  :value='tipo.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria")
                p.titulo Número portaria:
                el-input(
                  v-model="filtro.numeroPortaria"
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria")
              p.titulo Número publicação de portaria:
              el-input(
                v-model="filtro.numeroPublicacaoPortaria",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacao")
              p.titulo Número publicação:
              el-input(
                v-model="filtro.numeroPublicacaoPortaria",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria || showFiltroPublicacao")
              p.titulo Denominação do imóvel:
              el-input(
                v-model="filtro.denominacao",
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroPublicacaoPortaria || showFiltroPublicacao")
              p.titulo Período de publicação:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Período inicial",
                end-placeholder="Período Final",
                format="dd/MM/yyyy",
                v-model="filtro.periodoPublicacao"
                name='data',
              )
            el-col(:lg="6", :md="12", :sm="24")
              p.titulo Tipo de processo:
              div(v-if="showFiltroTipoMultiplo")
                el-select.full-width(
                  v-model='filtro.tipos',
                  placeholder='Selecione',
                  multiple,
                  clearable
                )
                  el-option(
                    v-for='tipo in tiposCadastroSelect',
                    :key='tipo.codigo',
                    :label='tipo.nome',
                    :value='tipo.codigo'
                  )
              div(v-else)
                el-select.full-width(
                  v-model='filtro.tipo',
                  placeholder='Selecione',
                  clearable
                )
                  el-option(
                    v-for='tipo in tiposCadastroSelect',
                    :key='tipo.codigo',
                    :label='tipo.nome',
                    :value='tipo.codigo'
                  )
            el-col(:lg="12", :md="12", v-if="showFiltro('filtroSituacaoBoleto') || isCof")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.situacao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacaoBoleto',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroTipoPagamento') || showFiltroTipoPagamentoCOF")
              p.titulo Tipo de Pagamento:
              el-select.full-width(
                v-model='filtro.tipoPagamentoVtn',
                placeholder='Selecione',
                clearable
              )
                el-option(key='A_VISTA', label='À vista', value='A_VISTA')
                el-option(key='PARCELADO', label='À prazo', value='PARCELADO')
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacao') && !showFiltro('isCPAV')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoes',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="!this.caixa.includes('vistoria-remota') && !this.caixasCadastroPendente.includes(this.caixa)")
              p.titulo Município:
              el-select.full-width(
                multiple
                v-model='filtro.municipio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showfiltrosInformacoes")
              p.titulo Status:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='status in statusSolicitacao',
                  :key='status.codigo',
                  :label='status.nome',
                  :value='status.codigo'
                )

          el-col(:lg="6", :md="12", :sm="24", v-if="showFiltroDataEmissaoTitulo")
            p.titulo Data de emissão do título:
            el-date-picker.full-width.input.date(
              v-bind="$attrs",
              type="daterange",
              start-placeholder="Período inicial",
              end-placeholder="Período Final",
              format="dd/MM/yyyy",
              v-model="filtro.dataEmissaoTitulo"
              name='data',
            )

          div(v-if="listaProcessosSelecionados")
            el-col.column-checkbox(:lg="6", :md="12", :sm="24" v-if="(!showFiltroPublicacaoPortaria && !showFiltroPublicacao)")
              el-checkbox(
                v-model="exibirProcessosSelecionados"
                @change="setCheckboxProcessosSelecionados()"
              )
                label.titulo Exibir apenas selecionados
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroStatusOrdemServico')")
              p.titulo Status da Ordem de Serviço:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='status in statusOs',
                  :key='status.codigo',
                  :label='status.nome',
                  :value='status.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroTitulo')")
              p.titulo Título/Certidão:
              el-input(
                v-model="filtro.numeroTitulo"
              )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroMunicipio')")
              p.titulo Município:
              el-select.full-width(
                multiple
                v-model='filtro.municipio',
                placeholder='Selecione',
                clearable,
                filterable,
                no-match-text="Município não encontrado",
                @clear="filtro.municipio = null"
              )
                el-option(
                  v-for='m in municipios',
                  :key='m.id',
                  :label='m.nome',
                  :value='m.id'
                )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroReceita')")
              p.titulo Receita:
              el-select.full-width(
                v-model='filtro.receita',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='receita in receitas',
                  :key='receita.codigo',
                  :label='receita.descricao',
                  :value='receita.id'
                )
            el-col(:lg="12", :md="12", v-if="showFiltro('filtroSituacao') && showFiltro('isCPAV')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.status',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoesCPAV',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )

            el-col(:lg="6", :md="12", v-if="showFiltro('filtroSituacaoCertidao')")
              p.titulo Situação Certidão:
              el-select.full-width(
                v-model='filtro.situacaoCertidao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacoesCertidao',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroDataVencimento')")
              p.titulo Data de Vencimento:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Data inicial",
                end-placeholder="Data Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataVencimento"
                name='data',
              )
            el-col(:lg="6", :md="12", v-if="showFiltro('filtroArquivadosGac')")
              p.titulo Data de Arquivamento:
              el-date-picker.full-width.input.date(
                v-bind="$attrs",
                type="daterange",
                start-placeholder="Data inicial",
                end-placeholder="Data Final",
                format="dd/MM/yyyy",
                v-model="filtro.dataArquivamento"
                name='data',
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroSituacaoBoleto')")
              p.titulo Situação:
              el-select.full-width(
                v-model='filtro.situacao',
                placeholder='Selecione',
                clearable
              )
                el-option(
                  v-for='situacao in situacaoBoleto',
                  :key='situacao.codigo',
                  :label='situacao.nome',
                  :value='situacao.codigo'
                )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroRua')")
              p.titulo Rua:
              el-input(
                v-model="filtro.rua"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroBairro')")
              p.titulo Bairro:
              el-input(
                v-model="filtro.bairro"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroRemessa')")
              p.titulo Remessa:
              el-input(
                v-model="filtro.remessa"
              )
            el-col(:lg="6", :md="12", :sm="24", v-if="showFiltro('filtroQuadra')")
              p.titulo Quadra:
              el-input(
                v-model="filtro.quadra"
              )
  .button-group
    .left-buttons(v-if="!pesquisaGeral")
      el-button.no-padding(
        v-if="showPesquisaAvancada"
        type="text",
        @click="changePesquisa"
      ) {{ tituloPesquisa }}
      el-button.no-padding(
        type="text",
        v-if="!campoSimplesObrigatorio"
        @click="limpar"
      ) Limpar
    .right-buttons
      el-button.btn(
        v-if="!filtro.simples",
        type="primary",
        id='botao-filtro-avancado'
        @click="pesquisar"
      )
        i.el-icon-search
        | &nbsp Pesquisar
</template>

<script>
import axios from '@/utils/api'
import FILTRO_EMPTY from '@/models/filtro'
import { mapActions, mapGetters } from 'vuex'
import { funcoes, tiposNaoOnerosoGroup, tiposPeasGroup, statusOs, situacaoBoleto,
  situacoesCertidao, statusSolicitacao, situacaoTituloCertidao, situacoesArquivados,
  situacaoClausulaResolutiva, situacoesCPAV, situacaoTituloCertidaoMa,
  situacaoTituloCertidaoBa, situacaoBA, situacaoCadastroPendente, situacaoCadastroPendenteGeo, situacaoCaixaEntradaVistoriaRemota,
  situacaoCaixaEmAnaliseVistoriaRemota } from '@/constants/selects'
import PermissaoHelper from '@/screens/analise/PermissaoHelper'
const { filtro } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const { tiposProcessos } = require('@/utils/' + process.env.ESTADO + '/regrasCentral').default
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {
  components: {
  },

  mixins: [
    PermissaoHelper
  ],

  props: {
    showPesquisaAvancada: {
      type: Boolean,
      default: true
    },
    showFiltroDataEmissaoTitulo: {
      type: Boolean,
      default: false
    },
    configuracaoFiltro: {
      type: Object,
      required: true
    },
    showFiltroTipoPagamentoCOF: {
      type: Boolean,
      default: false
    },
    isCof: {
      type: Boolean,
      default: false
    },
    showfiltrosInformacoes: {
      type: Boolean,
      default: false
    },
    listaProcessosSelecionados: {
      default: false
    },
    placeholder: {
      type: String,
      default: filtro.placeholder
    },
    filtroRapido: {
      type: Object,
      required: false
    },
    showFiltroPublicacaoPortaria: {
      type: Boolean,
      default: false
    },
    showFiltroPublicacao: {
      type: Boolean,
      default: false
    },
    showFiltroTipoMultiplo: {
      type: Boolean,
      default: false
    },
    pesquisaGeral: {
      type: Boolean,
      default: false,
      required: false
    },
    limparCampo: {
      type: Boolean,
      default: false,
      required: false
    },
    exibirFiltro: {
      type: Boolean,
      default: true
    },
    campoSimplesObrigatorio: {
      type: Boolean,
      default: false,
      require: false
    },
    naoInicializarInformacoesCaixa: {
      type: Boolean,
      default: false,
      require: false
    }
  },

  data () {
    return {
      funcoes,
      caixa: '',
      tiposNaoOnerosoGroup,
      tiposPeasGroup,
      statusSolicitacao,
      statusOs,
      situacoesCPAV,
      situacaoBoleto,
      situacoesCertidao,
      situacaoClausulaResolutiva,
      situacaoTituloCertidao: process.env.ESTADO === 'ma' ? situacaoTituloCertidaoMa : process.env.ESTADO === 'ba' ? situacaoTituloCertidaoBa : situacaoTituloCertidao,
      situacoes: [],
      setores: [],
      exibirProcessosSelecionados: false,
      municipios: [],
      situacoesArquivados,
      filtro: FILTRO_EMPTY(),
      credenciados: null,
      tipoCredenciado: [
        {
          name: 'Vistoria',
          codigo: 'VISTORIADOR_EXTERNO'
        }
      ],
      isBa: process.env.ESTADO === 'ba',
      isAp: process.env.ESTADO === 'ap',
      ordemServicoList: [],
      showErro: true
    }
  },

  async mounted () {
    if (this.naoInicializarInformacoesCaixa) {
      return
    }
    this.municipios = await this.findMunicipiosByEstadoAtual()
    this.caixa = this.$route.name
    if (this.configuracaoFiltro?.filtroCredenciado &&
      this.configuracaoFiltro?.filtroCredenciado.some(e => e === this.usuario.perfilSelecionado.codigo)
    ) {
      this.credenciados = await axios({
        method: 'GET',
        url: `portal/pessoa/findAllCredenciadoVistoria`,
        error: true
      })
    }
    if (this.caixa.includes('vistoria-remota')) {
      if (this.caixa.includes('caixa-entrada')) {
        this.situacoes = situacaoCaixaEntradaVistoriaRemota
      } else if (this.caixa.includes('caixa-em-analise')) {
        this.situacoes = situacaoCaixaEmAnaliseVistoriaRemota
      } else {
        this.situacoes = await axios({
          method: 'GET',
          url: `situacao`,
          error: true
        })
      }
    }
    if (this.caixa === 'receptor/listagem-cadastros-pendentes') {
      this.situacoes = situacaoCadastroPendente
    }
    if (this.caixa === 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO') {
      this.situacoes = situacaoCadastroPendenteGeo
    }
    if (this.caixa &&
      !this.caixa.includes('vistoria-remota') &&
      !this.caixasNaoBuscaUsuarioSetor.includes(this.caixa) &&
      !this.caixa.includes('vistoria-remota') &&
      !this.caixa.includes('manutencao') &&
      !this.caixa.includes('solicitacao')) {
      this.responsaveis = await this.getUsuariosPorSetor(this.caixa)
      if (this.showfiltrosInformacoes) {
        this.setores = await axios({
          method: 'GET',
          url: `solicitarInformacao/setores`,
          error: true
        })
        this.setores = this.setores.map(s => ({ ...s, nome: setoresFormatado[s.codigo] }))
      }
      const caixa = this.caixa === 'cof/gestaoVtn' ? 'GESTAO_VTN' : (this.caixa === 'gat/informacoesSolicitadas' || this.caixa === 'cof/informacoesSolicitadas' ? 'INFORMACAO_SOLICITADA' : this.caixa)
      if (this.isBa) {
        this.situacoes = situacaoBA
      } else {
        this.situacoes = await axios({
          method: 'GET',
          url: `processo/getSituacoesBycaixa/${caixa}`,
          loader: false
        })
      }
    }
    if (this.isBa) {
      this.funcoes = this.funcoes.filter(f => ['GEOMENSOR', 'VISTORIADOR'].includes(f.codigo))
    }
    if (this.showFiltro('filtroOS')) {
      this.ordemServicoList = await axios({
        method: 'GET',
        url: 'ordemServico/select/getAll'
      })
    }
  },

  computed: {

    ...mapGetters({
      usuario: 'auth/usuarioLogado'
    }),

    tituloPesquisa () {
      return this.filtro.simples ? 'Pesquisa avançada' : 'Pesquisa simplificada'
    },
    tiposCadastroSelect () {
      return tiposProcessos
    },
    numeroRecibo: {
      get () {
        return this.filtro.numeroRecibo
      },
      set (value) {
        this.filtro.numeroRecibo = value.toUpperCase()
      }
    },
    caixasNaoBuscaUsuarioSetor () {
      return ['portariaHomologacao', 'diagnostico/listagem', 'receptor/listagem-cadastros-pendentes', 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO']
    },
    caixasCadastroPendente () {
      return ['receptor/listagem-cadastros-pendentes', 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO']
    }
  },

  methods: {
    ...mapActions({
      getUsuariosPorSetor: 'dados/getUsuariosPorSetor',
      findMunicipiosByEstadoAtual: 'municipios/findMunicipiosByEstadoAtual'
    }),

    showFiltro (campo) {
      if (!this.usuario) {
        return false
      }
      return this.configuracaoFiltro[campo] && this.configuracaoFiltro[campo].find((perfil) => perfil === this.usuario?.perfilSelecionado.codigo)
    },

    limpar () {
      if (!this.filtro.simples) {
        this.filtro = { ...FILTRO_EMPTY(), simples: this.filtro.simples, simplificado: false }
        this.exibirProcessosSelecionados = false
        this.$emit('limpar')
      } else {
        this.filtro = { ...FILTRO_EMPTY(), simples: this.filtro.simples }
        this.exibirProcessosSelecionados = false
        this.$emit('limpar')
      }
    },

    changePesquisa () {
      this.filtro.simples = !this.filtro.simples
      this.filtro.campoSimples = ''
      this.filtro.cpfCnpjInteressado = ''
      this.filtro.nomeInteressado = ''
      this.filtro.numeroProcesso = ''
      this.filtro.municipio = []
      this.filtro.funcao = ''
      this.filtro.setorOrigem = ''
      this.filtro.tipo = ''
      this.filtro.dataVencimento = null
      this.filtro.dataArquivamento = null
      this.filtro.situacao = ''
      this.filtro.status = ''
      this.filtro.statusSolicitacao = ''
      this.filtro.statusOs = ''
      this.filtro.situacaoCertidao = ''
      this.filtro.tipoPagamentoVtn = ''
      this.filtro.situacaoClausulaResolutiva = ''
      this.filtro.ordem = ''
      this.filtro.receita = ''
      this.filtro.responsavel = ''
      this.filtro.setorOrigem = ''
      this.filtro.simplificado = this.caixasCadastroPendente.includes(this.caixa) ? this.filtro.simples : this.filtro.simplificado
    },

    pesquisar (invalid) {
      if (!invalid || !this.campoSimplesObrigatorio) {
        if (this.filtroRapido) {
          this.filtro = {
            ...this.filtro,
            ...this.filtroRapido
          }
        }
        this.$emit('pesquisar', this.filtro)
      }
      this.showErro = true
    },

    formatResponsavel (responsavel) {
      if (!this.showFuncaoResponsavel) {
        return responsavel.pessoa.pessoaFisica.nome
      }

      return `${responsavel.pessoa.pessoaFisica.nome} (${responsavel.perfis ? responsavel.perfis[0].nome : ''})`
    },

    setCheckboxProcessosSelecionados () {
      if (this.exibirProcessosSelecionados) {
        this.filtro.processos = this.listaProcessosSelecionados
      } else {
        this.filtro.processos = []
      }
    }
  },
  watch: {
    limparCampo (valor) {
      if (valor) {
        this.showErro = false
        this.filtro.campoSimples = ''
      }
    }
  }
}
</script>

<style scoped lang="scss">
.color-default {
  color: #009d64 !important;
  font-size: 16px;
}

.searchPanel {
  display: flex;
  flex-direction: column;
  margin-top: 20px;

  .button-group {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-top: 15px;
  }

  .no-padding {
    padding: 0;
  }

  .panel {
    .margin-top {
      margin-top: 10px;
    }

    .titulo {
      font-size: 14px;
    }
  }

  .btn {
    padding: 8px;
  }
}

.column-checkbox {
  padding-top: 20px;
  padding-bottom: 20px;
}

.full-width {
  width: 100%;
}

.titulo {
  margin: 0;
  padding: 12px 0 8px 0px;
}

.pesquisaGeralInput{
  height: 25px !important;
}

.pesquisaGeralButton {
  background-color: white !important;
}

.erro {
  color: red;
}

.limpar-e-erro {
  font-size: 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
</style>



// WEBPACK FOOTER //
// src/components/Filtro.vue